/**
 * @description 解析帮助中心内容关联产品的型号显示值
 * @reason 对齐 TDC PlatformContentLinkedOption 契约，仅读取 products[].label
 * @param {Object|null|undefined} item - 内容列表项或详情对象
 * @returns {Array<string>} 去重后的适用产品型号数组
 */
export function resolveApplicableProductModels(item) {
  if (!item || typeof item !== 'object') return []

  const applicableProductModels = normalizeUniqueText(item.applicableProductModels)
  if (applicableProductModels.length > 0) return applicableProductModels

  if (!Array.isArray(item.products)) return []
  return normalizeUniqueText(
    item.products.map((product) =>
      product && typeof product === 'object' ? product.label : undefined
    )
  )
}

function normalizeUniqueText(values) {
  if (!Array.isArray(values)) return []
  return [...new Set(values.map(normalizeText).filter(Boolean))]
}

function normalizeText(value) {
  if (value == null) return ''
  return String(value).trim()
}
